import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em"
  }, props), React.createElement("path", {
    d: "M16.424 2.424l-.848-.848L9 8.152 2.424 1.576l-.848.848L8.152 9l-6.576 6.576.848.848L9 9.848l6.576 6.576.848-.848L9.848 9z"
  }));
};

export default SvgComponent;